import React, { useContext, useEffect } from 'react';
import { Formik } from 'formik';
import * as yup from 'yup';
import { ApplicationFormStateContext } from '../../state/applicationFormState';
import { BackButton } from '../../components/BackButton';
import { trackEvent } from '../../utils/gtm';
import { scrollToTopOfContent } from '../../utils/scroll';
import { useNavigate } from 'react-router-dom';
import { Step } from '../../models/Step';

const errorMessageRentalCost = 'Indstast husleje pr. måned.  Har du ingen månedlig husleje indtast da et 0.';
const errorMessageLivingExpenses = 'Indtast realkredit og/eller boliglån. Har du ingen betalinger hertil indtast da et 0.'
const errorMessageOtherLoanExpenses = 'Indtast forbrugslån eller kreditter. Har du ingen indtast da et 0.'

const ExpensesStep: React.FunctionComponent = () => {
  const [state, dispatch] = useContext(ApplicationFormStateContext);
  const { monthlyRentalCost, householdLivingExpenses, householdOtherLoanExpenses } = state;
  const navigate = useNavigate();

  useEffect(() => {
    trackEvent({eventName: 'step_load', data: { step: 'Expenses' } });
    dispatch({ type: 'set_step', step: Step.Expenses });
    scrollToTopOfContent();
  }, []);

  const validationSchema = yup.object().shape({
      monthlyRentalCost: yup
        .number()
        .typeError(errorMessageRentalCost)
        .min(0, errorMessageRentalCost)
        .max(999999, errorMessageRentalCost)
        .required(errorMessageRentalCost),
      householdLivingExpenses: yup
        .number()
        .typeError(errorMessageLivingExpenses)
        .min(0, errorMessageLivingExpenses)
        .max(999999, errorMessageLivingExpenses)
        .required(errorMessageLivingExpenses),
      householdOtherLoanExpenses: yup
        .number()
        .typeError(errorMessageOtherLoanExpenses)
        .min(0, errorMessageOtherLoanExpenses)
        .max(999999, errorMessageOtherLoanExpenses)
        .required(errorMessageOtherLoanExpenses)
  });

  return (
    <>
      <h2>Udgifter</h2>
      
      <Formik
        initialValues={{ monthlyRentalCost, householdLivingExpenses, householdOtherLoanExpenses }}
        onSubmit={async (values) => {

          dispatch({
            type: 'set_expenses',
            monthlyRentalCost: values.monthlyRentalCost,
            householdLivingExpenses: values.householdLivingExpenses,
            householdOtherLoanExpenses: values.householdOtherLoanExpenses
          });

          navigate('/kreditkort');

        }}
        validationSchema={validationSchema}
      >
        {(formikProps) => (
          <div className="mt-5">
            <div>
              <label className="label-default">Husleje kr. pr. måned (kun leje eller boligafgiften)</label>
              <input
                type="text"
                name="monthlyRentalCost"
                defaultValue={formikProps.values.monthlyRentalCost}
                disabled={formikProps.isSubmitting}
                onChange={formikProps.handleChange}
                onBlur={formikProps.handleBlur}
                maxLength={6}
              />
              <p className="text-gray-600 text-xs italic">Den månedlige husleje skal angives.</p>
              {(formikProps.touched.monthlyRentalCost ||
                formikProps.submitCount > 0) &&
                formikProps.errors.monthlyRentalCost && (
                  <div className="invalid-feedback">
                    {formikProps.errors.monthlyRentalCost}
                  </div>
                )}
            </div>

            <div className="mt-5">
              <label className="label-default">Realkredit og/eller boliglån kr. pr. måned</label>
              <input
                type="text"
                name="householdLivingExpenses"
                defaultValue={formikProps.values.householdLivingExpenses}
                disabled={formikProps.isSubmitting}
                onChange={formikProps.handleChange}
                onBlur={formikProps.handleBlur}
                maxLength={6}
              />
              <p className="text-gray-600 text-xs italic">Den samlede betaling til realkredit og boliglån pr. måned skal angives.</p>
              {(formikProps.touched.householdLivingExpenses ||
                formikProps.submitCount > 0) &&
                formikProps.errors.householdLivingExpenses && (
                  <div className="invalid-feedback">
                    {formikProps.errors.householdLivingExpenses}
                  </div>
                )}
            </div>

            <div className="mt-5">
              <label className="label-default">Andre forbrugslån eller kreditter kr. pr. måned</label>
              <input
                type="text"
                name="householdOtherLoanExpenses"
                defaultValue={formikProps.values.householdOtherLoanExpenses}
                disabled={formikProps.isSubmitting}
                onChange={formikProps.handleChange}
                onBlur={formikProps.handleBlur}
                maxLength={6}
              />
              <p className="text-gray-600 text-xs italic">Betalinger til forbrugslån pr. måned skal angives.</p>
              {(formikProps.touched.householdOtherLoanExpenses ||
                formikProps.submitCount > 0) &&
                formikProps.errors.householdOtherLoanExpenses && (
                  <div className="invalid-feedback">
                    {formikProps.errors.householdOtherLoanExpenses}
                  </div>
                )}
            </div>

            <div className="container-btn">
              <BackButton />

              <button
                className="btn btn-next"
                type="submit"
                onClick={() => formikProps.submitForm()}
              >
                Næste
              </button>
            </div>
          </div>
        )}
      </Formik>
    </>
  );
};

export default ExpensesStep;
